/**
 * Splide custom buttons.
 */

/**
 * Button function.
 * @param  {object} block          the block or container splide lives in.
 * @param  {object} splideInstance the splide instance created when instatiating splide.
 */
const splideCustomButtons = (block, splideInstance) => {
	const prev = block.querySelector('.splide__text-button-previous');
	const next = block.querySelector('.splide__text-button-next');

	prev.onclick = () => {
		splideInstance.go('<');
	};

	next.onclick = () => {
		splideInstance.go('>');
	};

	const initButtonLogic = (newIndex) => {
		const { getAt, items } = splideInstance.Components.Pagination;
		const pagintationItem = getAt(newIndex) ?? { page: 0 };
		const { page } = pagintationItem;

		if (newIndex > 0) {
			prev.classList.remove('disabled');
		} else {
			prev.classList.add('disabled');
		}

		if (page !== (items.length - 1)) {
			next.classList.remove('disabled');
		} else {
			next.classList.add('disabled');
		}
	};

	splideInstance.on('move', (newIndex) => {
		initButtonLogic(newIndex);
	});

	splideInstance.on('updated', () => {
		splideInstance.go(0);
	});
};

export default splideCustomButtons;
